module.exports = __webpack_public_path__ + "static/BourrienneParisX-243c192702ceab8299c50f30f4f1dc63.jpg";